
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'الأمان والموثوقية',
      description: 'سائقون محترفون مرخصون مع سجل قيادة نظيف وخبرة طويلة في خدمة الحجاج والمعتمرين',
    },
    {
      icon: 'ri-time-line',
      title: 'خدمة 24/7',
      description: 'نعمل على مدار الساعة طوال أيام الأسبوع لخدمتكم في أي وقت تحتاجون فيه للتوصيل',
    },
    {
      icon: 'ri-car-line',
      title: 'أسطول فاخر',
      description: 'سيارات حديثة ونظيفة ومجهزة بأحدث وسائل الراحة والأمان لضمان رحلة مريحة',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'دعم متواصل',
      description: 'فريق خدمة عملاء متاح دائماً للرد على استفساراتكم ومساعدتكم في أي وقت',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'أسعار تنافسية',
      description: 'نقدم أفضل الأسعار مع الحفاظ على أعلى مستويات الجودة والخدمة المتميزة',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'معرفة بالطرق',
      description: 'سائقون على دراية تامة بجميع الطرق والمسارات للوصول إلى وجهتكم بأسرع وقت',
    },
  ];

  const values = [
    {
      title: 'الالتزام',
      description: 'نلتزم بمواعيدنا ونحرص على الوصول في الوقت المحدد دائماً',
      icon: 'ri-time-line',
    },
    {
      title: 'الاحترافية',
      description: 'نقدم خدماتنا بأعلى معايير الاحترافية والجودة',
      icon: 'ri-medal-line',
    },
    {
      title: 'الراحة',
      description: 'راحتكم وسلامتكم هي أولويتنا القصوى في كل رحلة',
      icon: 'ri-heart-line',
    },
  ];

  return (
    <div className="min-h-screen bg-luxury-cream">
      <Navbar />

      <main className="pt-32 pb-24">
        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-gold/10 to-transparent"></div>
          <div className="container mx-auto px-6 lg:px-20 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-luxury-black font-almarai font-black text-4xl lg:text-6xl mb-6">
                عن <span className="text-gold">فخامة الرفاهية</span>
              </h1>
              <div className="w-20 h-1 bg-gold mx-auto mb-8"></div>
              <p className="text-luxury-gray font-cairo text-xl leading-relaxed">
                رحلة من الفخامة والراحة في خدمة ضيوف الرحمن
              </p>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-6 lg:px-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="text-right">
                <h2 className="text-luxury-black font-cairo font-bold text-3xl mb-6">
                  قصتنا
                </h2>
                <p className="text-luxury-gray font-cairo text-lg leading-relaxed mb-4">
                  بدأت فخامة الرفاهية للتوصيل من رؤية بسيطة: توفير خدمة نقل فاخرة ومريحة للحجاج والمعتمرين القادمين لأداء مناسكهم في الأراضي المقدسة. منذ انطلاقتنا قبل أكثر من 8 سنوات، نجحنا في خدمة آلاف العملاء من مختلف أنحاء العالم.
                </p>
                <p className="text-luxury-gray font-cairo text-lg leading-relaxed">
                  نؤمن بأن رحلتكم الروحانية تستحق أن تبدأ براحة وطمأنينة، لذلك نحرص على توفير أعلى مستويات الخدمة والاحترافية في كل رحلة نقوم بها.
                </p>
              </div>
              <div className="relative">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src="https://public.readdy.ai/ai/img_res/b53120f8f5957786b7d23db7372a9dcb.jpg"
                    alt="سائق محترف"
                    className="w-full h-96 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
                <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold rounded-3xl -z-10"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 bg-luxury-cream">
          <div className="container mx-auto px-6 lg:px-20">
            <div className="text-center mb-16">
              <h2 className="text-luxury-black font-almarai font-bold text-4xl mb-4">
                لماذا <span className="text-gold">نحن؟</span>
              </h2>
              <div className="w-20 h-1 bg-gold mx-auto"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-right"
                >
                  <div className="w-16 h-16 flex items-center justify-center bg-gold/20 rounded-full mb-6">
                    <i className={`${feature.icon} text-gold text-3xl`}></i>
                  </div>
                  <h3 className="text-luxury-black font-cairo font-bold text-xl mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-luxury-gray font-cairo leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6 lg:px-20">
            <div className="text-center mb-16">
              <h2 className="text-luxury-black font-almarai font-bold text-4xl mb-4">
                قيمنا <span className="text-gold">الأساسية</span>
              </h2>
              <div className="w-20 h-1 bg-gold mx-auto"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="text-center p-8 bg-gradient-to-b from-gold/5 to-transparent rounded-2xl hover:from-gold/10 transition-all duration-300"
                >
                  <div className="w-20 h-20 flex items-center justify-center bg-gold rounded-full mx-auto mb-6">
                    <i className={`${value.icon} text-white text-4xl`}></i>
                  </div>
                  <h3 className="text-luxury-black font-cairo font-bold text-2xl mb-3">
                    {value.title}
                  </h3>
                  <p className="text-luxury-gray font-cairo leading-relaxed">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-luxury-black">
          <div className="container mx-auto px-6 lg:px-20 text-center">
            <h2 className="text-white font-almarai font-bold text-4xl mb-6">
              جاهزون لخدمتكم
            </h2>
            <p className="text-white/80 font-cairo text-xl mb-8 max-w-2xl mx-auto">
              تواصلوا معنا الآن واحجزوا رحلتكم المباركة بكل سهولة
            </p>
            <div className="flex items-center justify-center gap-4">
              <a
                href="https://wa.me/966XXXXXXXXX"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-cairo font-bold text-lg px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>تواصل عبر واتساب</span>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutPage;
